import { superRegionToCountryCode } from "./super-region-to-country.js";
import { superRegionDisplayNames } from "./super-region-to-display-names.js";
export const data = {
    OTHER: {
        name: superRegionDisplayNames.OTHER,
        parts: superRegionToCountryCode.OTHER,
    },
    REAP: {
        name: superRegionDisplayNames.REAP,
        parts: superRegionToCountryCode.REAP,
    },
    REAU: {
        name: superRegionDisplayNames.REAU,
        parts: superRegionToCountryCode.REAU,
    },
    REEU: {
        name: superRegionDisplayNames.REEU,
        parts: superRegionToCountryCode.REEU,
    },
    REME: {
        name: superRegionDisplayNames.REME,
        parts: superRegionToCountryCode.REME,
    },
    RENA: {
        name: superRegionDisplayNames.RENA,
        parts: superRegionToCountryCode.RENA,
    },
    RESA: {
        name: superRegionDisplayNames.RESA,
        parts: superRegionToCountryCode.RESA,
    },
};
